<script>
import { reactive } from "vue";
import { Head, Link, router } from '@inertiajs/vue3';
import BreezeLayout from '@/Layouts/Authenticated.vue';
import BreezeButton from '@/Components/Button.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';

export default {
    components: {
        BreezeLayout,
        BreezeButton,
        BreezeInput,
        BreezeLabel,
        Head,
        Link
    },
    props: {
        user: Object
    },
    setup(props) {
        console.log(props);
        const form = reactive({
            email: props.user.email,
            account_holder_code: props.user.profile.account_holder_code
        });

        const update = () => {
            router.put(route('profile.update', { user: props.user.id }), form);
        };

        return {
            form,
            update
        };
    },
}
</script>

<template>
    <Head title="Edit profile"/>

    <BreezeLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                <Link :href="route('profile.index')">My profile</Link>
            </h2>

        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-gray-100">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <div class="mt-10 sm:mt-0">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1 flex justify-between flex-col">
                                    <div class="px-4 sm:px-0">
                                        <h3 class="text-lg font-medium leading-6 text-gray-900">Editing Profile</h3>
                                        <p class="mt-1 text-sm text-gray-600">
                                            This is your data. So take care.<br><br>
                                            Make sure the account_holder_code is an NAWID that has sufficient roles in BGS.
                                        </p>
                                    </div>
                                    <div class="pb-2">
                                        <Link :href="route('profile.index')" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-slate-400 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-600">← BACK</Link>
                                    </div>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <form @submit.prevent="update">
                                        <div class="shadow overflow-hidden sm:rounded-md">
                                            <div class="px-4 py-5 bg-white sm:p-6 relative">
                                                <table class="table-auto w-3/4">
                                                    <caption class="hidden">Your profile</caption>
                                                    <tr>
                                                        <th class="text-left py-2">Fields</th>
                                                        <th class="text-left py-2">Values</th>
                                                    </tr>
                                                    <tr>
                                                        <td class="pr-5 py-2">Username</td>
                                                        <td class="py-2">{{ user.name }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="pr-5 py-2">Email*</td>
                                                        <td>
                                                            <BreezeInput 
                                                                id="email" 
                                                                type="email" 
                                                                v-model="form.email" 
                                                                required />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="pr-5 py-2">Account Holder Code*</td>
                                                        <td>
                                                            <BreezeInput 
                                                                id="account_holder_code" 
                                                                type="text"
                                                                v-model="form.account_holder_code" 
                                                                required />
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="flex justify-end px-4 py-3 bg-gray-50 text-right sm:px-6">
                                                <BreezeButton
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                    :class="{ 'opacity-25': form.processing }"
                                                    :disabled="form.processing">
                                                    Update
                                                </BreezeButton>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </BreezeLayout>
</template>